export type QueueTab = 'deletions' | 'exports';

export type QueueSearch = {
  tab: QueueTab;
  status?: string;
  /** Exports tab: the request the alert mail linked to. */
  request?: number;
  /** 1-based in the URL, 0-based in the table. */
  page?: number;
};

export const DELETION_STATUSES = ['open', 'done', 'cancelled', 'all'] as const;
export const EXPORT_STATUSES = ['open', 'sent', 'all'] as const;

export type DeletionStatus = (typeof DELETION_STATUSES)[number];
export type ExportStatus = (typeof EXPORT_STATUSES)[number];

/**
 * `status` is checked against the tab's own list, since the two tabs accept
 * different values. The default (`open`) is not written to the URL.
 */
export function validateQueueSearch(raw: Record<string, unknown>): QueueSearch {
  const tab: QueueTab = raw.tab === 'exports' ? 'exports' : 'deletions';
  const allowed: readonly string[] =
    tab === 'exports' ? EXPORT_STATUSES : DELETION_STATUSES;
  const out: QueueSearch = { tab };
  if (
    typeof raw.status === 'string' &&
    raw.status !== 'open' &&
    allowed.includes(raw.status)
  ) {
    out.status = raw.status;
  }
  const request = Number(raw.request);
  if (tab === 'exports' && Number.isInteger(request) && request > 0) {
    out.request = request;
  }
  const page = Number(raw.page);
  if (Number.isInteger(page) && page >= 1) out.page = page;
  return out;
}

export function deletionStatus(search: QueueSearch): DeletionStatus {
  return DELETION_STATUSES.find((s) => s === search.status) ?? 'open';
}

export function exportStatus(search: QueueSearch): ExportStatus {
  return EXPORT_STATUSES.find((s) => s === search.status) ?? 'open';
}
